// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ChevronDown = React.forwardRef(function ChevronDown(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronDown" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 17L5 9.83894L6.79759 8L12 13.3221L17.2024 8L19 9.83895L12 17Z", fill: "currentColor" }))));
});
ChevronDown.displayName = 'ChevronDown';
export default ChevronDown;
//# sourceMappingURL=ChevronDown.js.map